import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarEmpreedService } from "../services/buscarEmpreendimentosService";
import { cidadeService } from "../../../services/cidadeService";
// --------------------- Import Interfaces ---------------------
import { Empreendimento } from "../../../interfaces/Empreendimento";
import { Cidade } from "../../../interfaces/Cidade";

export const useEmpreendimentos = () => {
  const [empreendimentos, setEmpreendimentos] = useState<Empreendimento[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const buscar = async () => {
    const data = await buscarEmpreedService();
    const cidades = await cidadeService();

    const dataAtualizado = data.map((empreendimento: Empreendimento) => {
      const cidadeCorrespondente = cidades.find(
        (cidade: Cidade) => cidade.id === empreendimento.cidadeId
      );
      return {
        ...empreendimento,
        cidadeId: cidadeCorrespondente
          ? cidadeCorrespondente.nome
          : empreendimento.cidadeId, // Substitui pelo nome, se encontrado
      };
    });

    setEmpreendimentos(dataAtualizado);
    setIsLoading(false);
  };

  // UseEffect necessário para buscar as assinaturas
  useEffect(() => {
    buscar();
  }, []);

  return { empreendimentos, isLoading, buscar };
};
